import eventBus from '../core.js';

/** @TODO задача для рефакторинга https://jira.autoopt.ru/browse/IM-5699, чтобы уйти от jquery и библиотеки модалки */

const eventName = 'handleDeprecatedOpenModal';

const subscribe = callback => {
    return eventBus.subscribe(eventName, callback);
};

const broadcast = data => {
    return eventBus.broadcast(eventName, data);
};

export default {
    subscribe,
    broadcast,
};
